import React from 'react';
import { useLocalization } from '@ais-ui/locale-management';

interface EmptyListTableProps {
  entity: string;
  srcImage: string;
  children?: React.ReactNode;
}

export const EmptyListTable = ({
  entity,
  srcImage,
  children,
}: EmptyListTableProps) => {
  const { messages } = useLocalization();
  const message = messages.emptyStateNoItems?.replace('{entity}', entity) ?? `No ${entity} to display`;

  return (
    <div className="flex flex-col w-full max-w-full justify-center items-center self-center">
      <img
        className="w-auto h-32 mt-4 max-w-full object-contain"
        src={srcImage}
        alt="EmptyList"
      />
      <div className="flex flex-col items-center justify-center my-4 space-y-2 w-[60%]">
        <div className="text-sm text-muted-foreground text-center">{message}</div>
      </div>
      <div className={'flex w-[60%] justify-center items-center'}>
        {children}
      </div>
    </div>
  );
};
